import { ItemBookableExperience } from "lib/features/item/types";

export const removeExpiredTimes = (
  bookableExperiences: ItemBookableExperience[] | undefined
) => {
  // only show bookable experiences that are after the current date and time
  if (!bookableExperiences) return [];
  const currentDate = new Date();
  const currentTime = currentDate.getTime();
  const futureBookableExperiences = bookableExperiences.filter(
    (bookableExperience) => {
      const bookableExperienceDate = new Date(bookableExperience.start_date);
      const bookableExperienceTime = Number(bookableExperience.start_time); // Convert start_time to a number
      const dateHasPassed = bookableExperienceDate < currentDate;
      const dateIsToday =
        bookableExperienceDate.getDate() === currentDate.getDate();
      const timeHasPassed = bookableExperienceTime < currentTime; // Compare as numbers
      if (dateHasPassed || (dateIsToday && timeHasPassed)) {
        return false;
      }
      return true;
    }
  );
  return futureBookableExperiences;
};
